import * as React from 'react'

const Circle = (props: any) => (
  <svg {...props} viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="3" cy="3" r="2.5" />
  </svg>
)

export default Circle



// WEBPACK FOOTER //
// ./src/components/icons/ui/Circle.tsx